import React from 'react';
import { Box, Grid, Typography, Stack, Divider, Paper, alpha, useTheme } from '@mui/material';
import { useParams } from 'react-router-dom';
import { BiBuildings, BiBarcode, BiCollection, BiCalendar } from 'react-icons/bi';
import { useRoutineById } from 'redux/reducers/user/dashboard/tms-dashboardTrainee';

const InfoItem = ({ icon: Icon, label, value }: any) => (
  <Stack direction="row" spacing={1.5} alignItems="center">
    <Box sx={{ p: 1, bgcolor: alpha('#0B3F6B', 0.05), borderRadius: 2, display: 'flex' }}>
      <Icon size={20} color="#0B3F6B" />
    </Box>
    <Box>
      <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600, display: 'block' }}>
        {label}
      </Typography>
      <Typography variant="body2" sx={{ fontWeight: 700 }}>
        {value || 'N/A'}
      </Typography>
    </Box>
  </Stack>
);

const TrainingRoutine = () => {
  const { training_id: routineId } = useParams<{ training_id: string }>();
  const { data: routineDetail } = useRoutineById(routineId ? +routineId : undefined);

  return (
    <Box>
      <Typography variant="h6" sx={{ fontWeight: 800, color: 'primary.main', mb: 3 }}>
        Training Overview
      </Typography>
      
      <Grid container spacing={3}>
        {/* Main Details */}
        <Grid item xs={12} lg={4}>
          <Typography variant="subtitle2" color="text.secondary" gutterBottom>TRAINING NAME</Typography>
          <Typography variant="h6" sx={{ fontWeight: 700, lineHeight: 1.2 }}>
            {routineDetail?.training_details.training_name}
          </Typography>
        </Grid>

        <Grid item xs={12} lg={8}>
          <Grid container spacing={2}>
            <Grid item xs={6} sm={3}>
              <InfoItem icon={BiBarcode} label="CODE" value={routineDetail?.training_details?.training_code} />
            </Grid>
            <Grid item xs={6} sm={3}>
              <InfoItem icon={BiBuildings} label="HALL" value={routineDetail?.hall_details?.hall_name} />
            </Grid>
            <Grid item xs={6} sm={3}>
              <InfoItem icon={BiCollection} label="BATCH" value={routineDetail?.batch_name} />
            </Grid>
            <Grid item xs={6} sm={3}>
              <InfoItem icon={BiCalendar} label="TIMELINE" value={`${routineDetail?.start_date} - ${routineDetail?.end_date}`} />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default TrainingRoutine;